var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "produts" }, [
    _c("div", { staticClass: "produts-title" }, [_c("custom-breadcrumb")], 1),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "produts-search" },
      [
        _c(
          "el-form",
          { attrs: { inline: true, model: _vm.produtsForm } },
          [
            _c(
              "el-form-item",
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "Category", clearable: "" },
                    on: { change: _vm.search },
                    model: {
                      value: _vm.produtsForm.categoryId,
                      callback: function($$v) {
                        _vm.$set(_vm.produtsForm, "categoryId", $$v)
                      },
                      expression: "produtsForm.categoryId"
                    }
                  },
                  _vm._l(_vm.categorysList, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.cateName, value: item.id }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c("el-date-picker", {
                  attrs: {
                    "value-format": "yyyy-MM-dd",
                    format: "MM.dd.yyyy",
                    type: "date",
                    placeholder: "Last Update"
                  },
                  on: { change: _vm.search },
                  model: {
                    value: _vm.produtsForm.time,
                    callback: function($$v) {
                      _vm.$set(_vm.produtsForm, "time", $$v)
                    },
                    expression: "produtsForm.time"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-input",
                  {
                    staticClass: "input-with-select",
                    staticStyle: { width: "550px" },
                    attrs: {
                      placeholder: "Product name / Brands/Product ID",
                      clearable: ""
                    },
                    on: { clear: _vm.handleClearKeyWords },
                    model: {
                      value: _vm.produtsForm.keyWords,
                      callback: function($$v) {
                        _vm.$set(_vm.produtsForm, "keyWords", $$v)
                      },
                      expression: "produtsForm.keyWords"
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "el-input__icon el-icon-search",
                      attrs: { slot: "prefix" },
                      slot: "prefix"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "produts-search-button",
                        attrs: { slot: "append" },
                        on: { click: _vm.search },
                        slot: "append"
                      },
                      [_vm._v("\n            Search\n          ")]
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "products-content" },
      [
        _c(
          "el-table",
          {
            ref: "data-table",
            staticStyle: {
              width: "100%",
              "min-height": "calc(100vh - 400px)",
              "margin-bottom": "90px"
            },
            attrs: { data: _vm.tableData, stripe: "" },
            on: {
              "cell-mouse-enter": _vm.handleMouseEnter,
              "cell-mouse-leave": _vm.handleMouseLeave
            }
          },
          [
            _c("el-table-column", {
              attrs: { label: "Name", "min-width": "350" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("div", { staticClass: "table-name" }, [
                        _c("div", { staticClass: "table-img" }, [
                          _c("img", {
                            attrs: { src: scope.row.imgPath, alt: "" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(scope.row.skuName) +
                              "\n            "
                          )
                        ])
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "categroyName",
                "min-width": "100",
                label: "Category"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { "min-width": "180", label: "Wholesale Cost Price($)" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            scope.row.wholesaleCostPrice
                              ? "$" + scope.row.wholesaleCostPrice
                              : "——"
                          )
                        )
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                "min-width": "160",
                label: "Wholesale Price($)",
                "column-key": "uid"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        [
                          scope.$index === _vm.wholesaleEditIndex
                            ? _c("el-input", {
                                staticStyle: { width: "70px" },
                                attrs: {
                                  oninput:
                                    "\n              if(value){value=value.replace(/[^0-9.]/g,'')}\n              if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.handleUpdatePrice(scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.wholesalePrice,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "wholesalePrice", $$v)
                                  },
                                  expression: "scope.row.wholesalePrice"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          scope.$index !== _vm.wholesaleEditIndex
                            ? _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.wholesalePrice
                                        ? "$" + scope.row.wholesalePrice
                                        : "——"
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row["wholesalePriceDisplay"] === 1
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    color: "#000000",
                                    "font-weight": "600",
                                    "margin-left": "5px"
                                  },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleClickEdit(scope.$index)
                                    }
                                  }
                                },
                                [_vm._v("Edit\n            ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { "min-width": "180", label: "Shipping from Country" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            scope.row.shippingFromCountry
                              ? scope.row.shippingFromCountry
                              : "——"
                          )
                        )
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { "min-width": "150", label: "Inventory" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "table-url",
                          on: {
                            click: function($event) {
                              return _vm.handleInventory(scope.row)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.num) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { "min-width": "120", prop: "brandName", label: "Brand" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                "min-width": "120",
                prop: "updateAtStr",
                label: "Last Update"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { "min-width": "150", label: "Product Link" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "table-url",
                          on: {
                            click: function($event) {
                              return _vm.openUrl(scope)
                            }
                          }
                        },
                        [_vm._v("View")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.tableData.length > 0
      ? _c(
          "div",
          { staticClass: "page_table" },
          [
            _c("pagination", {
              attrs: {
                currentPage: _vm.paging.current,
                total: _vm.paging.total,
                pageSize: _vm.paging.size
              },
              on: {
                handleSizeChange: _vm.handleSizeChange,
                handleCurrentChange: _vm.handleCurrentChange
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76b8b556", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76b8b556","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wholesale/procurement-products.vue
// module id = mH+X
// module chunks = 2